import React, { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { FileText, Eye, EyeOff } from "lucide-react";
import { api } from "@/lib/api";
import { PrimStatementModal } from "@/components/prim/PrimStatementModal";
import { StatementViewBadge } from "./StatementViewBadge";

export function StatementActions({ p, onChanged, views }) {
  const [acik, setAcik] = useState(!!p.ekstre_acik);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const now = new Date();

  const toggle = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/personnel/${p.id}/ekstre-erisim`, { acik: !acik });
      setAcik(r.data.ekstre_acik);
      onChanged?.(p.id, r.data.ekstre_acik);
      toast.success(`${p.ad_soyad}: prim ekstresi ${r.data.ekstre_acik ? "açıldı" : "kapatıldı"}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Güncellenemedi");
    } finally { setBusy(false); }
  };

  return (
    <>
      {views && <StatementViewBadge p={p} v={views.views?.[p.id]} donem={views.donem} />}
      <button type="button" data-testid={`statement-open-${p.sicil_no}`} onClick={() => setOpen(true)}
        className="inline-flex items-center justify-center w-8 h-8 rounded-lg text-indigo-600 hover:bg-indigo-50 mr-1" title="Prim Ekstresi">
        <FileText size={14} />
      </button>
      <button type="button" data-testid={`statement-access-${p.sicil_no}`} onClick={toggle} disabled={busy}
        className={`inline-flex items-center justify-center w-8 h-8 rounded-lg mr-1 disabled:opacity-50 ${acik ? "text-emerald-600 hover:bg-emerald-50" : "text-slate-400 hover:bg-slate-100"}`}
        title={acik ? "Personel ekstresini görebiliyor · kapatmak için tıklayın" : "Personel ekstresini göremiyor · açmak için tıklayın"}>
        {acik ? <Eye size={14} /> : <EyeOff size={14} />}
      </button>
      {open && createPortal(<PrimStatementModal yil={now.getFullYear()} ay={now.getMonth() + 1} personnelId={p.id} onClose={() => setOpen(false)} />, document.body)}
    </>
  );
}
